<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('status-employee') }}</label>
                    <div class="col-12 md:col-5">
                        <Dropdown :class="{'p-invalid' : submitted && !form.employee_status }"
                                v-model="form.employee_status"
                                :options="employeeStatus"
                                placeholder="Select Employment Status" required="true"/>
                        <small class="p-invalid" v-if="submitted && !form.employee_status"
                            >{{ $t('status-employee') }} is required.</small>
                    </div>
                </div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('start-date') }}</label>
					<div class="col-12 md:col-5">
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        :class="{'p-invalid' : submitted && !form.start_date }"
                        v-model="form.start_date"
                        dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.start_date"
                            >{{ $t('start-date') }} is required.</small
                        >
					</div>
                    <div class="col-12 mt-2 md:col-1">
                        <label for="name3">{{ $t('end-date') }}</label>
                    </div>
                    <div class="col-12 md:col-4">
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        :class="{'p-invalid' : submitted && !form.end_date }"
                        v-model="form.end_date"
                        dateFormat="yy-mm-dd" />
                        <small class="p-invalid" v-if="submitted && !form.end_date"
                            >{{ $t('end-date') }} is required.</small
                        >
                    </div>
				</div>
                <div class="field grid">
                    <label for="contract_number" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('contract-number') }}</label>
                    <div class="col-12 md:col-5">
                        <Dropdown :class="{'p-invalid' : submitted && !form.contract_number }"
                            :options="contractNumbers"
                            v-model="form.contract_number"
                            option-label="value" option-value="code"
                            placeholder="Select Contract Duration" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.contract_number"
                            >{{ $t('contract-number') }} is required.</small
                        >
                    </div>
                </div>
                <div class="field grid">
                    <label for="contract_duration" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('contract-duration') }}</label>
                    <div class="col-12 md:col-5">
                        <Dropdown :class="{'p-invalid' : submitted && !form.contract_duration }"
                            :options="contractDurations"
                            v-model="form.contract_duration"
                            placeholder="Select Contract Duration" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.contract_duration"
                            >{{ $t('contract-duration') }} is required.</small
                        >
                    </div>
                </div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('placement') }}</label>
					<div class="col-12 md:col-5">
						<Dropdown :class="{'p-invalid' : submitted && !form.placement_id }"
                                v-model="form.placement_id"
                                :options="placements"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Placement" required="true"/>
                        <small class="p-invalid" v-if="submitted && !form.placement_id"
                            >{{ $t('placement') }} is required.</small
                        >
					</div>
				</div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('division') }}</label>
					<div class="col-12 md:col-5">
						<Dropdown :class="{'p-invalid' : submitted && !form.division_id }"
                                v-model="form.division_id"
                                :options="divisions"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Division" required="true"/>
                        <small class="p-invalid" v-if="submitted && !form.division_id"
                            >{{ $t('division') }} is required.</small
                        >
					</div>
				</div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('position') }}</label>
					<div class="col-12 md:col-5">
                        <Dropdown
                                :class="{'p-invalid' : submitted && !form.position_id }"
                                v-model="form.position_id"
                                :options="positions"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Position" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.position_id">
                            {{ $t('position') }} is required.
                        </small>
					</div>
				</div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('position-class') }}</label>
					<div class="col-12 md:col-5">
                        <Dropdown
                                :class="{'p-invalid' : submitted && !form.position_classes_id }"
                                v-model="form.position_classes_id"
                                :options="positionClasses"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Position Class" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.position_classes_id">
                            {{ $t('position-class') }} is required.
                        </small>
					</div>
				</div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">BPJS Jaminan Hari Tua [JHT]</label>
                        <Checkbox id="jht" class="mx-2 mx-2" v-model="form.is_jht" :binary="true" name="is_jht" />
                        <label for="jht">yes</label>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">BPJS Jaminan Pensiun [JP]</label>
                        <Checkbox id="jp" class="mx-2 mx-2" v-model="form.is_jp" :binary="true" name="is_jp" />
                        <label for="jp">yes</label>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">BPJS Jaminan Kematian [JKM]</label>
                        <Checkbox id="jp" class="mx-2 mx-2" v-model="form.is_jkm" :binary="true" name="is_jkm" />
                        <label for="jp">yes</label>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">BPJS Jaminan Kecelakaan Kerja [JKK]</label>
                        <Checkbox id="jp" class="mx-2 mx-2" v-model="form.is_jkk" :binary="true" name="is_jkk" />
                        <label for="jp">yes</label>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">BPJS Kesehatan</label>
                        <Checkbox id="jk" class="mx-2 mx-2" v-model="form.is_bpjs_kesehatan" :binary="true" name="is_bpjs_kesehatan" />
                        <label for="jk">yes</label>
                </div>

                <hr />

                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('bank') }}</label>
					<div class="col-12 md:col-5">
                        <Dropdown
                                :class="{'p-invalid' : submitted && !form.bank_id }"
                                v-model="form.bank_id"
                                :options="banks"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Bank" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.bank_id">
                            {{ $t('bank') }} is required.
                        </small>
					</div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('account-bank-name') }}</label>
					<div class="col-12 md:col-5">
                        <InputText id="account_name" type="text" v-model="form.account_name" placeholder="Ex. John Doe" :class="{'p-invalid' : submitted && !form.account_name }"/>
                        <small class="p-invalid" v-if="submitted && !form.account_name">
                            {{ $t('account-bank-name') }} is required.
                        </small>
					</div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">{{ $t('account-bank-number') }}</label>
					<div class="col-12 md:col-5">
                        <InputText id="account_number" type="text" v-model="form.account_number" placeholder="Ex. 839392939" :class="{'p-invalid' : submitted && !form.account_number }"/>
                        <small class="p-invalid" v-if="submitted && !form.account_number">
                            {{ $t('account-bank-number') }} is required.
                        </small>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
export default{
    components:{
        Button, Calendar, Checkbox, Dropdown, InputText, InputNumber,
    },
    props: ['model','submitted'],
    data(){
        return{
            form: {
                employee_status: "",
                start_date: "",
                end_date: "",
                contract_number: "",
                contract_duration: "",
                placement_id: "",
                division_id: "",
                position_id: "",
                position_classes_id: "",
                bank_id: this.$page.props.candidate.data.bank ? this.$page.props.candidate.data.bank.bank_id : "",
                account_name: this.$page.props.candidate.data.bank ? this.$page.props.candidate.data.bank.account_name : "",
                account_number: this.$page.props.candidate.data.bank ? this.$page.props.candidate.data.bank.account_number : "",
            },
            employeeStatus: ['contract', 'permanent', 'training'],
            contractNumbers: [
                {code: 1, value: 'I'},
                {code: 2, value: 'II'},
                {code: 3, value: 'III'},
                {code: 4, value: 'IV'},
                {code: 5, value: 'V'},
                {code: 6, value: 'VI'},
                {code: 7, value: 'VII'},
                {code: 8, value: 'VII'},
                {code: 9, value: 'IX'},
                {code: 10, value: 'X'},
                {code: 11, value: 'XI'},
                {code: 12, value: 'XII'},
            ],
            contractDurations: ['one week', 'two weeks', 'three weeks', 'one month', 'two months','three months','four months','five month','six months','seven months','eight months','nine months','ten months','eleven months','one year','two year','three year','four year','five year'],
            placements: [],
            divisions: [],
            positions: [],
            positionClasses: [],
            employees: [],
            banks: [],
        }
    },
    mounted(){
        // this.form.position_id = this.form.position_id ?? this.model.position_id;
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/banks`)
            .then((data)=>{
                this.banks = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data)=>{
                this.placements = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
            .then((data)=>{
                this.divisions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/positions`)
            .then((data)=>{
                this.positions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/position-classes`)
            .then((data)=>{
                this.positionClasses= data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/employees`)
            .then((data)=>{
                this.employees = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        },
    },
}
</script>
